<button  [disabled]="disabled" class="btn rounded-btn btn-primary submitBtn"  [style.pointer-events]="spin?'none':''"  id=submitBtn>
   <span style="color: transparent;" *ngIf="spin" [nbSpinner]="true">ABC</span>
   &nbsp;  <ng-content></ng-content> &nbsp;
 </button>
 